export default __webpack_public_path__ + "static/media/je.b7d319dd.svg";